<template>
    <div class="">
        <MudarSenha :showModal="showModalSenha"></MudarSenha>
        <MeusDados :showModal="showModalDados"></MeusDados>

        <DadosInstituicao :showModal="showModalDadosInstituicao"></DadosInstituicao>

        <ModalNormativa :showModal="showModalNormativa"></ModalNormativa>

        <MetodoTrabalho :showModal="showModalMetodo"></MetodoTrabalho>
        <ManualUsuario :showModal="showManualUsuario"></ManualUsuario>

        <ModalNps v-if="false"></ModalNps>

    </div>
</template>
<script>
    import MudarSenha from '@/components/MudarSenha'
    import MeusDados from '@/components/MeusDados'
    import DadosInstituicao from '@/components/DadosInstituicao'
    import ModalNormativa from '@/components/ModalNormativa'
    import MetodoTrabalho from '@/components/MetodoTrabalho'
    import ManualUsuario from '@/components/ManualUsuario'
    import ModalNps from '@/components/ModalNps'

    export default {
        name: 'Modais',
        components: { MudarSenha, MeusDados, ModalNormativa, MetodoTrabalho, ManualUsuario, ModalNps, DadosInstituicao },
        computed: {
            user() {
                return this.$store.state.user
            },
            showModalSenha() {
                return this.$store.state.showModalSenha
            },
            showModalDados() {
                return this.$store.state.showModalDados
            },
            showModalDadosInstituicao() {
                return this.$store.state.showModalDadosInstituicao
            },
            showModalMetodo() {
                return this.$store.state.showModalMetodo
            },
            showModalNormativa() {
                return this.$store.state.showModalNormativa
            },
            showManualUsuario() {
                return this.$store.state.showManualUsuario
            },
        },
        data: function () {
            return {

            }
        },

        methods: {
            load() {
                this.$nextTick(function () {
                    setTimeout(function () {
                        document.addEventListener('hide.bs.modal', function () {
                            if (document.activeElement) {
                                document.activeElement.blur();
                            }
                        });
                    }, 1000)
                });
            },

        },
        mounted: function () {
            this.load();
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
</style>

